Ext.define('SA.lq.view.LocationsCombo', {
    constructor(cmp) {
        this.cmp = cmp;
    },

    getValue() {
        return this.cmp.getValue();
    },

    setState(state) {
        var value = state.getSelectedLocationStringId(),
            items = state.getSelectableLocations().map(location => ({
                locationStringId: location.getStringId(),
                name: location.getName(),
                locationAlias: location.isSeries() ? location.getAlias() : null,
                isCombo: location.isCombo(),
                isRadius: location.isRadius()
            }));

        this.cmp.setState({items, value});
    }
});